import { Box, Button, Grid } from "@mui/material";
import pxToRem from "theme/base/pxToRem";
import { useDispatch, useSelector } from "react-redux";
import {
  categoryOptionSelector,
  formFilterEmployeeLeaveSelector,
} from "modules/DeclareLeave/redux/selector";
import { useFormFlow, useFormUpdate, useRefsManager } from "helper/customHook";
import FormSelect from "components/common/Form/FormSelect";
import { FormInput } from "components/common/Form";
import { memo } from "react";

import { resetControlPageFilter } from "components/common/ListInfinitiveScrolling/redux/controlInfinitiveScrolling";
import {
  CATEGORY_TYPE,
  getCategoryOptionStart,
} from "modules/DeclareLeave/redux/getCategoryOption";
import { formFilterEmployeeLeaveUpdate } from "modules/DeclareLeave/redux/formFilterEmployeeLeave";
import { useParams } from "react-router-dom";
import { declareLeaveURL } from "../../..";
import {
  getListEmployeeLeaveRequestStart,
  resetListEmployeeLeaveRequest,
} from "modules/DeclareLeave/redux/getListEmployeeLeaveRequest";
import {
  getListEmployeeFeedbackRequestStart,
  resetListEmployeeFeedbackRequest,
} from "modules/DeclareLeave/redux/getListEmployeeFeedbackRequest";
import {
  getListEmployeeArriveLateRequestStart,
  resetListEmployeeArriveLateRequest,
} from "modules/DeclareLeave/redux/getListEmployeeArriveLateRequest";
import { exportEmployeeRequestStart } from "modules/DeclareLeave/redux/exportEmployeeRequest";

const FilterEmployeeOrder = memo(() => {
  const { type } = useParams();
  const dispatch = useDispatch();

  const formData = useSelector(formFilterEmployeeLeaveSelector);
  const { DEPT_LEVEL1, DEPT_LEVEL2, WORKING_AREA, LEAVE_REASON_TYPE } =
    useSelector(categoryOptionSelector);

  const { attachRef, elementsRef } = useRefsManager();

  const handleFilter = () => {
    const tab = type;

    if (!tab || tab === declareLeaveURL.leave) {
      dispatch(
        resetControlPageFilter({ id: "employeeLeaveRequest", limit: 60 })
      );
      dispatch(resetListEmployeeLeaveRequest());
      dispatch(getListEmployeeLeaveRequestStart());
    } else if (tab === declareLeaveURL.feedback) {
      dispatch(
        resetControlPageFilter({ id: "employeeFeedbackRequest", limit: 60 })
      );
      dispatch(resetListEmployeeFeedbackRequest());
      dispatch(getListEmployeeFeedbackRequestStart());
    } else {
      dispatch(resetListEmployeeArriveLateRequest());
      dispatch(
        resetControlPageFilter({ id: "employeeArriveLateRequest", limit: 60 })
      );
      dispatch(getListEmployeeArriveLateRequestStart());
    }
  };

  const { handleInputChange, handleSelectChange } = useFormUpdate(
    formFilterEmployeeLeaveUpdate,
    () => {
      handleFilter();
    }
  );

  const { handleNext } = useFormFlow(elementsRef, []);

  return (
    <Box sx={{ marginBlock: pxToRem(20), width: "100%" }}>
      <Grid container spacing={1} width={"100%"}>
        <Grid item lg={4} md={4} sm={6} xs={6}>
          <FormSelect
            name={"workingAreaCode"}
            formData={formData}
            formErrors={{}}
            placeholder="Khu vực"
            labelColor={"textSecondary"}
            attachRef={attachRef}
            onChange={handleSelectChange}
            onKeyDown={(name: string) => handleNext(name)}
            options={WORKING_AREA || []}
            fontSize={14}
          />
        </Grid>
        <Grid item lg={4} md={4} sm={6} xs={6}>
          <FormSelect
            name={"departmentLevel1Code"}
            formData={formData}
            formErrors={{}}
            placeholder="Đơn vị cấp 1"
            labelColor={"textSecondary"}
            attachRef={attachRef}
            onChange={(name) => (e) => {
              handleSelectChange(name)(e);
              dispatch(
                getCategoryOptionStart({
                  categoryType: CATEGORY_TYPE.DEPT_LEVEL2,
                  departmentCode: e,
                })
              );
            }}
            onKeyDown={(name: string) => handleNext(name)}
            options={DEPT_LEVEL1 || []}
            fontSize={14}
          />
        </Grid>
        <Grid item lg={4} md={4} sm={6} xs={6}>
          <FormSelect
            name={"departmentLevel2Code"}
            formData={formData}
            formErrors={{}}
            placeholder="Đơn vị cấp 2"
            labelColor={"textSecondary"}
            attachRef={attachRef}
            onChange={handleSelectChange}
            onKeyDown={(name: string) => handleNext(name)}
            options={DEPT_LEVEL2 || []}
            fontSize={14}
          />
        </Grid>
        {/* <Grid item lg={4} md={3} sm={6} xs={6}>
          <FormSelect
            name={"positionCode"}
            formData={formData}
            formErrors={{}}
            placeholder="Chức danh"
            labelColor={"textSecondary"}
            attachRef={attachRef}
            onChange={handleSelectChange}
            onKeyDown={(name: string) => handleNext(name)}
            options={JOB_TITLE || []}
            fontSize={14}
          />
        </Grid> */}

        <Grid item lg={4} md={4} sm={6} xs={6}>
          <FormInput
            name={"searchText"}
            formData={formData}
            formErrors={{}}
            placeholder="Tìm nhân sự"
            labelColor={"textSecondary"}
            attachRef={attachRef}
            onChange={handleInputChange}
            onKeyDown={(name: string) => handleNext(name)}
            inputProps={{ sx: { padding: pxToRem(10) } }}
            fontWeight={400}
            fontSize={14}
          />
        </Grid>
        {(!type || type === declareLeaveURL.leave) && (
          <Grid item lg={4} md={4} sm={6} xs={6}>
            <FormSelect
              name={"leaveReasonType"}
              formData={formData}
              formErrors={{}}
              placeholder="Loại hình nghỉ"
              // label="Người liên quan (nếu có)"
              labelColor={"textSecondary"}
              attachRef={attachRef}
              onChange={handleSelectChange}
              onKeyDown={(name: string) => handleNext(name)}
              options={LEAVE_REASON_TYPE || []}
              fontSize={14}
            />
          </Grid>
        )}
      </Grid>
      <Box
        display={"flex"}
        justifyContent={"flex-end"}
        sx={(theme) => ({
          marginTop: pxToRem(20),
          [theme.breakpoints.down("md")]: {
            justifyContent: "center",
          },
        })}
      >
        <Button
          onClick={() => {
            dispatch(exportEmployeeRequestStart(type));
          }}
          variant="outlined"
          color="primary"
          sx={{ width: pxToRem(162) }}
        >
          Xuất Excel
        </Button>
      </Box>
    </Box>
  );
});
export default FilterEmployeeOrder;
